import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=1e9b0431&scoped=true"
import script from "./formList.vue?vue&type=script&lang=js"
export * from "./formList.vue?vue&type=script&lang=js"
import style0 from "./formList.vue?vue&type=style&index=0&id=1e9b0431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b0431",
  null
  
)

export default component.exports